module.exports = __webpack_public_path__ + "img/check-big.33f745d7.svg";